module.exports = {"431382001":"蓝田街道","431382100":"六亩塘镇","431382101":"石马山镇","431382102":"安平镇","431382103":"湄江镇","431382104":"伏口镇","431382105":"桥头河镇","431382106":"七星街镇","431382107":"杨市镇","431382108":"枫坪镇","431382109":"斗笠山镇","431382110":"水洞底镇","431382111":"白马镇","431382112":"茅塘镇","431382113":"荷塘镇","431382114":"金石镇","431382115":"龙塘镇","431382116":"渡头塘镇","431382200":"三甲乡","431382202":"古塘乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431382.json
// module id = 1765
// module chunks = 0